import React from "react"
import { type ChakraProps, Heading, useColorMode } from "@chakra-ui/react"
import { Colors } from "../../theme/colors"

interface Heading2CapsPropsInterface {
  text: string
  variantText?: [string, string, string]
  props?: ChakraProps
}
export const Heading3PT = ({ text, variantText = ["RHeading3PT", "RHeading3PT", "Heading3PT"], props }: Heading2CapsPropsInterface): JSX.Element => {
  const { colorMode } = useColorMode()

  return (
    <Heading
      color={colorMode === "light" ? Colors.Secondary.c2 : "white"}
      variant={variantText}
      borderBottomWidth="2px"
      borderBottomColor={Colors.Primary.accent}
      textAlign={"left"}
      p="10px"
      py="10px"
      mt="30px"
      maxW={["100%", "100%", "100%"]}
      display={"inline-block"}
      {...props}
    >
      {text}
    </Heading>
  )
}
// mt: ['30px', '30px', '24px']
